import {navigateTo} from '@typed-router';
import {defineNuxtRouteMiddleware} from '#app';

/** 
In some cases, when users are on Safari and use the browser back button during login, 
they can end up on /dashboard/freelancer/signin or /dashboard/freelancer/who-are-you, 
which leads to an error page (see Sentry issues MALT-48AZ & MALT-49A7).

This middleware ensures those users are redirected to the correct page.
*/
export default defineNuxtRouteMiddleware((to) => {
    if (process.dev) {
        return;
    }
    const urlsToRedirect = ['/signin', '/who-are-you'];
    const redirectUrl = urlsToRedirect.find((url) => url === to.path);
    if (redirectUrl) {
        return navigateTo(redirectUrl, {external: true});
    }
});
